import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { portalDelete, portalList } from "../../redux/actions/portalAction";
import moment from "moment";
import Loading from "../../components/ui/loader/loader";
import { useNavigate } from "react-router-dom";
import errorToast from "../../components/toast/errorToast";
import successToast from "../../components/toast/successToast";
import { GrMoreVertical } from "react-icons/gr";
import "./portal.css";
import Pagination from "../../components/ui/pagination/pagination";
import { useAuth } from '../../context/AuthContext';

/**Portal Module */
const Portal = () => {
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [portalData, setPortalData] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const [showClearIndex, setShowClearIndex] = useState(null);
  const [paginationData, setPaginationData] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [countData, setCountData] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const { isAdmin } = useAuth();

  const handleMoreOptionsClick = (item, index) => {
    setShowOptions(true);
    setShowClearIndex(index);
  };

  const handleDelete = (item) => {
    dispatch(portalDelete({ id: item?.id }, onDeleteSuccess, onError));
    setShowOptions(false);
  };

  const onDeleteSuccess = (data) => {
    successToast(data.data.message);
    reloadData();
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowOptions(false);
      setShowClearIndex(null);
    }
  };

  const onSuccess = (data) => {
    setPortalData(data.data.data.portals);
    setCountData(data.data.data.translatedCountData);
    setPaginationData(data.data.data.pagination);
    setLoading(false);
  };

  const onError = (data) => {
    errorToast(data.data.message);
  };

  const fetchData = () => {
    dispatch(portalList({ page }, onSuccess, onError));
  };

  const reloadData = () => {
    fetchData();
  };

  useEffect(() => {
    setLoading(true);
    dispatch(portalList({ page, page_size: rowsPerPage }, onSuccess, onError));
  }, [page, rowsPerPage]);

  console.log('paginationData', paginationData);
  useEffect(() => {
    document.title = 'Portals - Acumen Translation Hub';
  }, []);

  return (
    <div className="w-100 mt-1" onClick={handleClickOutside}>
      <div className="d-flex gap-3 align-items-center py-2 border-bottom position-sticky top-0 bg-white">
        <h2 className="fs_20 fw_400 fn_Roboto text-start mx-3">Portals</h2>
        {isAdmin &&
          <label
            className="fs_16 fw_600 cursor_pointer text-nowrap mb-1"
            onClick={() => navigate("/portal-create")}
            style={{ color: "#3367D6" }}
          >
            + CREATE PORTAL
          </label>
        }
      </div>
      <div className="row mx-3 mt-2">
        <div className="col-12">
          <div className="card">
            <div className="row text-center mt-2">
              <div className="col-md-4 mb-3">
                <h6>Total pages translated</h6>
                <p className="fs-5">{countData?.totalNumPages}</p>
              </div>
              <div className="col-md-4 mb-3">
                <h6>Pages translated by Basic users</h6>
                <p className="fs-5">{countData?.totalBasicUserCount}</p>
              </div>
              {/* <div className="col-md-4 mb-3">
                <h6>Pages translated by Advanced user</h6>
                <p className="fs-5">{countData?.totalAdvanceUserCount}</p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4 text-start mx-3">
        <p>
          Portals provide a dedicated user interface where invited users can
          translate content. You can create multiple portals for different
          sets of users.{" "}
          <a
            href="https://cloud.google.com/translation-hub/docs/admin-enable-translations?_gl=1*1qzglh8*_ga*MzA3NzExMzYyLjE3MTE2ODg5NTg.*_ga_WH2QY8WWF5*MTcxMzMzMDY1My40NS4xLjE3MTMzMzA2ODcuMC4wLjA.&_ga=2.142866103.-307711362.1711688958&_gac=1.182776276.1713330669.Cj0KCQjwqpSwBhClARIsADlZ_Tk7I9CWN_Klw2a7aPHXlup07MsPzxOv51pbpJrr4n2vYoYQDKUWUDgaArWREALw_wcB"
            target="_blank"
            style={{ color: "#3393E6", textDecoration: "underline" }}
          >
            Learn more
          </a>
        </p>
        <div className="table-responsive" style={{ minHeight: '30rem' }}>
          <table className="table table-bordered table-hover">
            <thead className="table-light" >
              <tr>
                <th>Portal Name</th>
                <th>Portal Id</th>
                {/* <th>Service Account</th> */}
                <th>Price Tier</th>
                <th>Create Time</th>
                {isAdmin && <th></th>}
              </tr>
            </thead >
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6">
                    <Loading text={"Loading contents"} style={{ height: "5rem" }} />
                  </td>
                </tr>
              ) : portalData?.length > 0 ? (
                portalData.map((item, index) => (
                  <tr key={item?.id}>
                    <td>
                      <a href={`/portal-view/${item.id}`} >
                        {item?.portal_name}
                      </a>
                    </td>
                    <td>{item?.id}</td>
                    {/* <td>{"service data has to be updated"}</td> */}
                    <td>{item?.price_tier.toUpperCase()}</td>
                    <td>
                      {moment(item?.createdAt).format("MM/DD/YY, hh:mm A")}
                    </td>
                    {isAdmin &&
                      <td>
                        <GrMoreVertical
                          className="cursor_pointer"
                          onClick={() => handleMoreOptionsClick(item, index)}
                        />
                        {showOptions && showClearIndex === index && (
                          <div className="position-relative" ref={dropdownRef}>
                            <div className="position-absolute" style={{ left: "-4rem" }}>
                              <div className="card">
                                <div className="card-body p-2 hover-effect">
                                  <label className="d-block text-danger cursor_pointer" onClick={() => handleDelete(item)}>Delete</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </td>
                    }
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Rows to display</td>
                </tr>
              )}
            </tbody>
          </table >
        </div >
        {paginationData?.total > 10 && (
          <div className="d-flex mt-1 pb-3 mx-4 justify-content-end">
            <Pagination
              data={paginationData}
              nextFunc={() => setPage(page + 1)}
              prevFunc={() => setPage(page - 1)}
              setPageRowFunc={(value) => {
                setPage(1);
                setRowsPerPage(value);
              }}
            />
          </div>
        )}
      </div >
    </div >
  );
};

export default Portal;
